/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_MetricsInputs */

const en_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics`)
};

const ar_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقاييس`)
};

const bn_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেট্রিক`)
};

const de_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriken`)
};

const es_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas`)
};

const fr_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métriques`)
};

const pt_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas`)
};

const zh_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指标`)
};

const tr_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrikler`)
};

const ru_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метрики`)
};

const pl_svchip_metrics = /** @type {(inputs: Svchip_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane`)
};

/**
* | output |
* | --- |
* | "Metrics" |
*
* @param {Svchip_MetricsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_metrics = /** @type {((inputs?: Svchip_MetricsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_MetricsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_metrics(inputs)
	if (locale === "bn") return bn_svchip_metrics(inputs)
	if (locale === "de") return de_svchip_metrics(inputs)
	if (locale === "es") return es_svchip_metrics(inputs)
	if (locale === "fr") return fr_svchip_metrics(inputs)
	if (locale === "pt") return pt_svchip_metrics(inputs)
	if (locale === "zh") return zh_svchip_metrics(inputs)
	if (locale === "tr") return tr_svchip_metrics(inputs)
	if (locale === "ru") return ru_svchip_metrics(inputs)
	if (locale === "pl") return pl_svchip_metrics(inputs)
	return en_svchip_metrics(inputs)
});